<template>
  <div>
    <div>
      <h2>{{ $t("application.text") }}</h2>
    </div>

    <sweet-button :loading="isUpdating" variant="secondary" icon="mdi mdi-pen-remove" @click="showModal" size="sm" class="float-right">
      {{ $t("application.new") }}
    </sweet-button>
    <b-dropdown v-if="pagination && pagination.docs.length" split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="float-right mr-2">
      <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
    </b-dropdown>
    <br />
    <br />

    <Modal :id="'application-form-modal'" @onSent="paginate()" />
    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <!-- -- Contexts -->
        <thead class="bg-secondary text-white">
          <tr>
            <th>{{ $t("application.category.text") }}</th>
            <th>{{ $t("product.text") }}</th>
            <th>{{ $t("application.subject") }}</th>
            <th>{{ $t("application.full-name") }}</th>
            <th>{{ $t("application.no") }}</th>
            <th>{{ $t("application.phone") }}</th>
            <th>{{ $t("application.email") }}</th>
            <th>{{ $t("application.department") }}</th>
            <th>{{ $t("application.relation") }}</th>
            <th>{{ $t("application.communication") }}</th>
            <th>{{ $t("application.date") }}</th>
            <th>{{ $t("application.deadline-date") }}</th>
            <th>{{ $t("application.priority") }}</th>
            <th>{{ $t("application.situation") }}</th>
            <th>{{ $t("application.note") }}</th>

            <th>
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>
        <tbody v-if="filterEnabled">
          <tr>
            <th></th>
            <th>
              <select class="form-control " v-model="productFilter">
                <option :value="undefined">{{ $t("common.clear-selection") }}</option>
                <option v-for="item in products" :key="item" :value="item">{{ item }}</option>
              </select>
            </th>
            <th></th>
            <th><input class="form-control" v-model="nameFilter" /></th>
            <th><input class="form-control" v-model="idNoFilter" /></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </tbody>
        <tbody>
          <template v-if="pagination">
            <!-- -- table data start -->
            <tr v-for="item in pagination.docs" :key="item._id">
              <td>
                <div v-for="category in item.category" :key="category._id">
                  <li>
                    {{ category.name | translate }}
                  </li>
                </div>
              </td>
              <td>
                {{ item.product | translate }}
              </td>
              <td>
                {{ item.applicationSubject | translate | summary(200) }}
              </td>
              <td>
                {{ item.firstAndLastName }}
              </td>

              <td>{{ item.idNo }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.department.name | translate }}</td>
              <td>{{ item.relationship.name | translate }}</td>
              <td>{{ item.applicationMethod.name | translate }}</td>
              <td>{{ item.applicationDate | date }}</td>
              <td>{{ item.deadlineDate | date }}</td>
              <td>{{ item.priority.name | translate }} <draft-badge entity-type="APPLICATION" :entity-id="item._id" /></td>
              <td>{{ item.situation.name | translate }}</td>
              <td>{{ item.applicationNote | translate | summary(200) }}</td>
              <td>
                <div class="font-size-16 text-center">
                  <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                  <i class="bx bx-trash text-danger hand ml-2" v-b-tooltip.hover :title="$t('common.edit')" @click="remove(item)"></i>
                </div>
              </td>
            </tr>
            <!-- --table data end -->
          </template>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />

    <!-- Begin: Pagination -->
    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("announcement.no") }}
      </h5>
    </empty>

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import DraftBadge from "@/modules/approval/draft-badge";
import DatePicker from "vue2-datepicker";

import Modal from "../application/application-modal.vue";

const state = "application";

export default {
  components: { DraftBadge,
    DatePicker,
    Modal,
  },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15 },
        query: {},
      },
      nameFilter: undefined,
      idNoFilter: undefined,
      productFilter: undefined,
      filterEnabled: false,
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },

    nameFilter(n, o) {
      const normalized = n ? this.toTurkishRegex(n) : null;
      this.request.query = {
        ...this.request.query,
        firstAndLastName: normalized ? { value: { $regex: normalized, $options: "i" }, isObject: true } : undefined,
      };
    },
    productFilter(n, o) {
      if (!n) {
        this.request.query = { ...this.request.query, product: undefined };
        return;
      }
      this.request.query = {
        ...this.request.query,
        product: { value: n, isObject: true },
      };
    },
    idNoFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        idNo: n ? { value: { $regex: n, $options: "i" }, isObject: true } : undefined,
      };
    },
    "$route.params.id": {
      async handler(n, o) {
        if (n) {
          await this.findById(n);
          this.edit(this.selectedEntity);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    selectedEntity() {
      return this.$store.getters[`${state}/selectedEntity`];
    },
  },

  async mounted() {
    // TKP-138: onay açıkken listedeki taslak rozetleri için (entities ekranındaki TKP-104 deseni)
    const { data } = await this.$store.dispatch("approval/status").catch(() => ({ data: null }));
    if (data && data.enabled) await this.$store.dispatch("approval/fetch").catch(() => undefined);
  },
  methods: {
    toTurkishRegex(value) {
      return value
        .replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1")
        .replace(/[iİıI]/g, "[iİıI]")
        .replace(/[uUüÜ]/g, "[uUüÜ]")
        .replace(/[oOöÖ]/g, "[oOöÖ]")
        .replace(/[gGğĞ]/g, "[gGğĞ]")
        .replace(/[sSşŞ]/g, "[sSşŞ]")
        .replace(/[cCçÇ]/g, "[cCçÇ]");
    },
    async paginate() {
      const payload = {
        ...this.request,
        query: {
          ...this.request.query,
          ...(this.currentProduct ? { product: { value: this.currentProduct, isObject: true } } : {}),
        },
      };
      await this.$store.dispatch(`${state}/paginate`, payload);
    },
    async findById(id) {
      return this.$store.dispatch(`${state}/findById`, id);
    },
    init() {
      this.paginate();
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },

    async remove(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, item._id);
        this.paginate();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async edit(item) {
      await this.findById(item._id);

      this.$store.commit(`${state}/editedEntity`, { ...this.selectedEntity });
      this.$root.$emit("bv::toggle::modal", "application-form-modal");
    },

    showModal() {
      this.$root.$emit("bv::toggle::modal", "application-form-modal");
    },

    async downloadExcel() {
      try {
        const { data: file } = await this.$store.dispatch(`${state}/download`, {
          product: this.currentProduct || undefined,
        });
        this.$store.commit("fileManager/addDownloadedFile", { file });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
